import asyncThunk from '@/lib/asyncThunk'
import { Admin } from '@/out/admin'

export type Request = Record<never, never>

export const listAdmins = asyncThunk<Request, Admin[]>({
  name: 'admins/list',
  uri: '/admins',
})
